import classNames from 'classnames';
import React from 'react';
import { HEADER_LEVEL_DEFAULT, HEADER_LEVEL_MAP } from './const';
import { HeaderProps } from './types';

export const Header: React.FC<HeaderProps> = ({
  level = HEADER_LEVEL_DEFAULT,
  children,
  className,
  ...restProps
}) => {
  const LevelTag = HEADER_LEVEL_MAP[level] || 'div';

  return (
    <LevelTag className={classNames('cms-header', className)} {...restProps}>
      {children}
    </LevelTag>
  );
};
